import { useEffect, useState } from 'react';
import AssignEmployeeComp from '@components/Fireboard/components/AssignEmployee/employeeView';
import { setErrorPopUp, setNotification } from '@reducers/notification';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';
import { getPopupConfig } from '@components/common/Popup/index';
import { useOutletContext } from 'react-router-dom';
import constant from '@components/common/globalization';
import {
  removeTableAssignment,
  assignTable,
  getStationEmployees,
} from '@reducers/fireboard/assignEmployee.js';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const AssignTable = props => {
  const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'));
  const stationEmpData = useSelector(
    state => state.assignEmployee.stationEmpData
  );
  const [activeTab, setActiveTab] = useState(constant.ALL);
  const [searchVal, setSearchVal] = useState('');
  const [tableSearchVal, setTableSearchVal] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [activeEmp, setActiveEmp] = useState();
  const [activeStations, setActiveStation] = useState({});
  const { getPopup, popup, setPopup } = useOutletContext();
  const employeeData = stationEmpData?.employeeStations.sort((a, b) => {
    const nameA = a.employee?.firstName?.toLowerCase() || '';
    const nameB = b.employee?.firstName?.toLowerCase() || '';
    return nameA.localeCompare(nameB);
  });

  useEffect(() => {
    getPopup('spinner', null, false);
    props
      .getStationEmployees({ storeId: deviceInfo?.storeId })
      .then(() => setPopup(null))
      .catch(error =>
        props.setErrorPopUp({
          res: error.message,
        })
      );
  }, []);

  useEffect(() => {
    if (!employeeData) return;
    let filtered = employeeData;

    if (activeTab === constant.ASSIGNED) {
      filtered = filtered.filter(x => x.stations.length > 0);
    } else if (activeTab === constant.UNASSIGNED) {
      filtered = filtered.filter(x => x.stations.length === 0);
    }

    if (searchVal.trim()) {
      const value = searchVal.toLowerCase();
      filtered = filtered.filter(({ employee }) => {
        const firstName = employee?.firstName || '';
        const lastName = employee?.lastName || '';
        const posId = employee?.posId || '';
        return (
          firstName.toLowerCase().includes(value) ||
          lastName.toLowerCase().includes(value) ||
          posId.toLowerCase().includes(value)
        );
      });
    }

    setFilteredData(filtered);
  }, [employeeData, activeTab, searchVal]);

  useEffect(() => {
    const tables = stationEmpData?.stationEmployees;
    let tableData = tables;
    if (tableSearchVal?.trim()) {
      const value = tableSearchVal.toLowerCase();
      tableData = tableData?.filter(station => {
        return (
          station?.station?.number?.toLowerCase().includes(value) ||
          station.station?.revenueCenterName?.toLowerCase().includes(value)
        );
      });
    }
    setFilteredTableData(tableData);
  }, [stationEmpData, tableSearchVal]);

  useEffect(() => {
    setActiveEmp(filteredData?.[0]);
  }, [filteredData]);

  const onFilterChange = data => {
    setSearchVal('');
    setActiveTab(data);
  };

  const onSearchEmployee = event => {
    setSearchVal(event);
  };

  const onDeleteTable = (tableData, employee, type) => {
    const deleteTable = () => {
      getPopup('spinner', null, false);
      const data = {
        employeeId: employee.id,
        stationIds: type === 'delete' ? [tableData.id] : [],
        storeId: deviceInfo?.storeId,
      };
      props
        .removeTableAssignment(data)
        .then(() => {
          setPopup(null);
          props.setNotification({
            type: 'success',
            message: FLABEL().TOAST_DELETE_TABLE,
          });
        })
        .catch(error =>
          props.setErrorPopUp({
            res: error.message,
          })
        );
    };

    const popup = getPopupConfig('success');
    popup.heading = FLABEL().ASSIGN_EMPLOYEE_DELETE_TABLE;
    const template =
      type === 'deleteAll'
        ? FLABEL()?.ASSIGN_EMPLOYEE_DELETEALL_TABLE_MESSAGE
        : FLABEL()?.ASSIGN_EMPLOYEE_DELETE_TABLE_MESSAGE;
    popup.message = template
      .replace(
        '{{TableNo}}',
        tableData?.number ?? tableData?.name ?? tableData?.posId
      )
      .replace('{{posId}}', employee?.posId ?? '');
    popup.buttons = [
      {
        btnType: 'cancel',
        text: FLABEL().ASSIGN_EMPLOYEE_NO,
        onClick: () => {
          setPopup(null);
        },
      },
      {
        btnType: 'submit',
        text: FLABEL().ASSIGN_EMPLOYEE_YES,
        onClick: () => {
          deleteTable();
        },
      },
    ];
    setPopup(popup);
  };

  const onStationClick = table => {
    setActiveStation(prev => {
      const newActive = { ...prev };
      if (newActive[table.id]) {
        delete newActive[table.id];
      } else {
        newActive[table.id] = table;
      }
      return newActive;
    });
  };

  const onAssignTable = () => {
    const assignTable = () => {
      getPopup('spinner', null, false);
      const data = {
        employeeId: activeEmp?.employee.id,
        stationIds: Object.keys(activeStations),
        storeId: deviceInfo?.storeId,
      };
      props
        .assignTable(data)
        .then(() => {
          setPopup(null);
          props.setNotification({
            type: 'success',
            message: FLABEL().TOAST_ASSIGN_TABLE,
          });
        })
        .catch(error =>
          props.setErrorPopUp({
            res: error.message,
          })
        );
      setActiveStation({});
    };
    const popup = getPopupConfig('success');
    popup.heading = FLABEL().ASSIGN_EMPLOYEE_ASSIGN_TABLE;
    popup.message = FLABEL()?.ASSIGN_EMPLOYEE_ASSIGN_TABLE_MESSAGE.replace(
      '{{posId}}',
      activeEmp?.employee?.posId ?? ''
    );

    popup.buttons = [
      {
        btnType: 'cancel',
        text: FLABEL().ASSIGN_EMPLOYEE_NO,
        onClick: () => {
          setPopup(null);
        },
      },
      {
        btnType: 'submit',
        text: FLABEL().ASSIGN_EMPLOYEE_YES,
        onClick: () => {
          assignTable();
        },
      },
    ];
    setPopup(popup);
  };

  return (
    <>
      <AssignEmployeeComp
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        searchVal={searchVal}
        setSearchVal={setSearchVal}
        filteredData={filteredData}
        activeEmp={activeEmp}
        stationEmpData={stationEmpData}
        setTableSearchVal={setTableSearchVal}
        tableSearchVal={tableSearchVal}
        setActiveEmp={setActiveEmp}
        filteredTableData={filteredTableData}
        setFilteredTableData={setFilteredTableData}
        activeStations={activeStations}
        setActiveStation={setActiveStation}
        onFilterChange={e => onFilterChange(e)}
        onSearchEmployee={e => onSearchEmployee(e)}
        onDeleteTable={(data, id, type) => onDeleteTable(data, id, type)}
        onStationClick={e => onStationClick(e)}
        onAssignTable={e => onAssignTable(e)}
      />
    </>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setErrorPopUp,
      setNotification,
      getStationEmployees,
      removeTableAssignment,
      assignTable,
    },
    dispatch
  );
export default connect(null, mapDispatchToProps)(AssignTable);
